import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PaiementAlmaIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 25 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M23.5781 10.155V10.845C23.1562 10.365 22.5781 10.02 21.8594 10.02C20.5 10.02 19.4375 11.19 19.4375 12.69C19.4375 14.19 20.5156 15.36 21.8594 15.36C22.6406 15.36 23.2812 15.015 23.6406 14.4V15.225H25V10.155H23.5781ZM22.2188 14.07C21.4375 14.07 20.8594 13.455 20.8594 12.705C20.8594 11.955 21.5 11.34 22.2188 11.34C22.9375 11.34 23.5781 11.955 23.5781 12.705C23.5781 13.455 23 14.07 22.2188 14.07ZM7.42188 8.77501H8.84375V15.225H7.42188V8.77501ZM10.4219 12.345C10.4219 10.98 11.2812 10.02 12.5625 10.02C13.3438 10.02 13.9219 10.365 14.2813 10.905C14.6406 10.35 15.2812 10.02 16 10.02C17.2188 10.02 18.1406 10.905 18.1406 12.345V15.225H16.7188V12.21C16.7188 11.655 16.3594 11.325 15.8594 11.325C15.3594 11.325 15 11.67 15 12.21V15.225H13.5781V12.21C13.5781 11.655 13.2188 11.325 12.7188 11.325C12.2188 11.325 11.8594 11.67 11.8594 12.21V15.225H10.4375V12.345M4.85938 10.215C4.5 9.04501 3.78125 8.64001 3.14062 8.64001C2.5 8.64001 1.78125 9.04501 1.42188 10.215L0 15.225H1.42188C1.64062 14.4 2.34375 13.92 3.14062 13.92C3.9375 13.92 4.64062 14.4 4.85938 15.225H6.28125L4.85938 10.215ZM3.14062 12.75C2.71875 12.75 2.28125 12.885 2 13.155L2.78125 10.275C2.85938 10.005 3 9.93001 3.14062 9.93001C3.28125 9.93001 3.42188 10.005 3.5 10.275L4.28125 13.155C4 12.945 3.5625 12.75 3.14062 12.75Z"
				fill="currentColor"
			/>
		</svg>
	);
}

PaiementAlmaIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PaiementAlmaIcon;
